(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown',event=>{if(event.target.id==='EsteemPromo'&&event.key==='Enter'){event.preventDefault();document.querySelector('[data-esteem-apply]')?.click();}});
document.addEventListener('click',async event=>{
 const button=event.target.closest('[data-esteem-apply]');if(!button)return;
 const input=document.getElementById('EsteemPromo');const status=document.getElementById('EsteemPromoStatus');const code=input.value.trim();
 if(!code){status.textContent='Enter a promo code first.';input.focus();return;}
 button.disabled=true;status.textContent='Checking your code…';
 try{
  const root=window.Shopify?.routes?.root||'/';
  const beforeResponse=await fetch(root+'cart.js');if(!beforeResponse.ok)throw Error();const before=await beforeResponse.json();
  const codes=[...new Set([...(before.discount_codes||[]).map(c=>c.code),code])];
  const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:codes.join(',')})});
  if(!response.ok)throw Error();const cart=await response.json();
  const matched=(cart.discount_codes||[]).find(c=>c.code.toLowerCase()===code.toLowerCase());
  const applications=[...(cart.cart_level_discount_applications||[]),...cart.items.flatMap(i=>(i.line_level_discount_allocations||[]).map(a=>a.discount_application))];
  const applied=matched?.applicable||applications.some(a=>a.title?.toLowerCase()===code.toLowerCase());
  status.textContent=applied?'Code applied. Your cart total reflects the available discount.':code.toUpperCase()==='NEWSLETTER10'?'This offer requires your subscribed email at checkout and applies to single shirts only. No newsletter saving is confirmed yet.':'This code does not apply to this cart yet. Check its spelling and requirements; customer-specific codes may need your email at checkout.';
  document.dispatchEvent(new CustomEvent('theme:cart:refresh',{bubbles:true}));
 }catch(error){status.textContent='We could not check this code. Please try again, or enter it at checkout.';}finally{button.disabled=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["esteem-desktop-buy"]) return;
  try {
    
(function(){
  function initialize(){
    const bar=document.querySelector('[data-esteem-desktop-buy]');
    const main=document.querySelector('[data-section-type="product"]');
    if(!bar||!main||bar.dataset.ready)return;
    const source=main.querySelector('[data-add-to-cart]');
    const form=source?.closest('form');
    if(!source||!form)return;
    bar.dataset.ready='true';
    const add=bar.querySelector('[data-esteem-buy-add]');
    const edit=bar.querySelector('[data-esteem-buy-edit]');
    const selection=bar.querySelector('[data-esteem-buy-selection]');
    const price=bar.querySelector('[data-esteem-buy-price]');
    const desktop=window.matchMedia('(min-width:990px)');
    let queued=false;
    function viewProduct(){
      const target=main.querySelector('input[type="radio"],select[name^="options"]')||source;
      target.focus({preventScroll:true});
      target.scrollIntoView({behavior:'auto',block:'center'});
    }
    function refresh(){
      queued=false;
      const active=desktop.matches&&source.getBoundingClientRect().bottom<0;
      bar.hidden=!active;
      document.documentElement.classList.toggle('esteem-desktop-buy-active',active);
      if(!desktop.matches)return;
      const options=Array.from(main.querySelectorAll('input[type="radio"][name^="options"]:checked,select[name^="options"]')).map(el=>el.value);
      const quantity=form.querySelector('[name="quantity"]')?.value||'1';
      selection.textContent=options.join(' / ')+(quantity!=='1'?' × '+quantity:'');
      price.textContent=main.querySelector('.product__price')?.textContent.trim()||'';
      add.textContent=source.querySelector('[data-add-to-cart-text]')?.textContent.trim()||source.textContent.trim();
      add.disabled=source.disabled||source.classList.contains('is-loading')||source.getAttribute('aria-busy')==='true';
    }
    function schedule(){if(!queued){queued=true;requestAnimationFrame(refresh);}}
    edit.addEventListener('click',viewProduct);
    add.addEventListener('click',()=>{
      refresh();
      if(add.disabled)return;
      if(!form.reportValidity()){viewProduct();return;}
      source.click();
      schedule();
    });
    main.addEventListener('change',schedule);
    main.addEventListener('input',schedule);
    new MutationObserver(schedule).observe(main,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','class','value','aria-busy']});
    const errors=main.querySelector('[data-cart-errors-container]');
    if(errors)new MutationObserver(()=>{
      if(errors.textContent.trim())errors.scrollIntoView({behavior:'auto',block:'center'});
    }).observe(errors,{subtree:true,childList:true,characterData:true});
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    refresh();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["esteem-minimal-footer"] && !Shopify.designMode) return;
  try {
    
  async function esteemNewsletterApply(scope = document) {
    for (const footer of scope.querySelectorAll('[data-esteem-footer]')) {
      const success = footer.querySelector('[data-newsletter-success]');
      if (!success || success.dataset.processed) continue;
      success.dataset.processed = 'true';
      const status = success.querySelector('[data-newsletter-status]');
      const root = window.Shopify?.routes?.root || '/';
      try {
        const cartResponse = await fetch(root + 'cart.js', {credentials:'same-origin'});
        if (!cartResponse.ok) throw new Error('Cart unavailable');
        const cart = await cartResponse.json();
        const codes = (cart.discount_codes || []).map(item => item.code).filter(Boolean);
        codes.push(footer.dataset.code);
        const response = await fetch(root + 'cart/update.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({discount:[...new Set(codes)].join(',')})});
        if (!response.ok) throw new Error('Discount unavailable');
        await response.json();
        status.textContent = status.dataset.saved;
      } catch (error) {
        status.textContent = status.dataset.failed;
      }
    }
  }
  esteemNewsletterApply();
  document.addEventListener('shopify:section:load', () => esteemNewsletterApply());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["esteem-product-tools"] && !Shopify.designMode) return;
  try {
    
(function(){
function initialize(){
const config=document.querySelector('[data-esteem-product-tools]');
if(!config)return;
const main=document.querySelector('[data-section-type="product"]');
if(!main)return;
const gallery=main.querySelector('product-images');
if(gallery){
const chart=[...gallery.querySelectorAll('.product__slide[data-type="image"]')].find(slide=>{
const image=slide.querySelector('img');
return image && /size[\s_-]*chart|sizing[\s_-]*chart|B076B55LF1listing-06/i.test((image.alt||'')+' '+(image.getAttribute('src')||''));
});
if(chart){
const id=chart.dataset.mediaId;
chart.id=chart.id||id;
main.querySelectorAll('product-modal a[data-popup-open]').forEach(link=>{
if(link.dataset.esteemChartBound)return;
if(!/size chart/i.test(link.textContent)&&!link.querySelector('.btn-size-chart'))return;
link.dataset.esteemChartBound='true';
link.setAttribute('href','#'+chart.id);
link.addEventListener('click',event=>{
event.preventDefault();event.stopImmediatePropagation();
chart.querySelector('img')?.setAttribute('loading','eager');
gallery.dispatchEvent(new CustomEvent('theme:media:select',{detail:{id}}));
gallery.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
},true);
});
}
}
main.querySelectorAll('label, option').forEach(element=>{
const walker=document.createTreeWalker(element,NodeFilter.SHOW_TEXT);
let node;while((node=walker.nextNode())){if(/^\s*1\s*pack\s*$/i.test(node.nodeValue))node.nodeValue=config.dataset.single;}
});
document.querySelectorAll('.accordion-group').forEach(group=>{
if(group.dataset.esteemCompact)return;
const questions=[...group.querySelectorAll('.accordion-group__items > details')];
if(questions.length<=2)return;
group.dataset.esteemCompact='true';group.classList.add('esteem-faq-compact');
const rest=questions.slice(2);rest.forEach(q=>q.hidden=true);
const button=document.createElement('button');button.type='button';button.className='esteem-faq-toggle';button.textContent=config.dataset.more;button.setAttribute('aria-expanded','false');
const container=group.querySelector('.accordion-group__items');container.id=container.id||group.id+'-questions';button.setAttribute('aria-controls',container.id);
button.addEventListener('click',()=>{
const expanded=button.getAttribute('aria-expanded')==='true';
rest.forEach(q=>q.hidden=expanded);
button.setAttribute('aria-expanded',String(!expanded));button.textContent=expanded?config.dataset.more:config.dataset.less;
if(expanded)group.scrollIntoView({behavior:'auto',block:'start'});
});
container.after(button);
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
document.addEventListener('shopify:section:load',initialize);
document.addEventListener('theme:product:loaded',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["esteem-style-switcher"] && !Shopify.designMode) return;
  try {
    
(function () {
  function showCurrentStyle() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.esteem-style-switch__items').forEach(function (list) {
      var active = list.querySelector('[aria-current="page"]');
      if (!active) return;
      var listRect = list.getBoundingClientRect();
      var activeRect = active.getBoundingClientRect();
      list.scrollLeft += activeRect.left - listRect.left - (listRect.width - activeRect.width) / 2;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showCurrentStyle, { once: true });
  } else {
    showCurrentStyle();
  }
  document.addEventListener('shopify:section:load', showCurrentStyle);
}());

  } catch(e) { console.error(e); }
})();
})();
